<!--Bed Visibility-->
<div class="app-ui-engine-container _wf-db-mainshadesiv _wf-bd-mainshagemobile main-box-shadow">
  @if (resource) {
    <div class="_wf-db-bordershade">
      @if (filterAr != undefined && filterAr.length) {
        <div class="row mt-2">
          <div class="drug-filter-container d-flex w-100 ml-2 mr-4 justify-content-between">
            <div class="bookmarks-container ml-2 mr-2">
              <div class="col-12 p-0">
                @for (filter of filterAr; track filter) {
                  <div class="fav-bookmark">
                    @if (checkFilterCondition(filter)) {
                      <div class="bookmark-chip"
                        [ngClass]="filter.name == filterConfig.FilterName ? 'active': ''" style="cursor: pointer;">
                        <span (click)="applyFilter(filter)"> {{ filter.name }}</span>
                        @if (filter.name == filterConfig.FilterName) {
                          <i class="fa fa-check ml-1"></i>
                        }
                      </div>
                    }
                  </div>
                }
                @if (preferenceData && preferenceData['filter__'] != undefined && preferenceData['filter__'].length > 0) {
                  <a href="javascript:void(0)" title="Manage Filters" (click)="manageFilter()" class="_fav-3-dots">
                    <div class="_fav-3-dots-container">
                      <img src="assets/images/icon-context.svg">
                    </div>
                  </a>
                }
              </div>
            </div>
          </div>
        </div>
      }
      <div class="_wf-db-topicons-2">
        @if (resource && resource.filter != undefined) {
          <div class="grid-search-wrapper">
            <div class="_filter-button-wrapper">
              <ng-container>
                <div class="_filter-button" (click)="displayFilter()">
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </div>
              </ng-container>
            </div>
            <div style="margin-left: 1px;">
              <app-complex-search [config]="config" (onFilterChange)="onFilterClick($event);">
              </app-complex-search>
            </div>
          </div>
        }
      </div>
      <div class="bed-visibility">
        <div class="bed-visibility-label">
          Bed Visibility
        </div>
        @if (count) {
          <div class="bed-total-count">
            Overall occupancy {{total_occupancy}}%({{total_vacant}} / {{count}})
          </div>
        }
        <div class="bed-stages">
          @for (v of resource.css | keyvalue:originalOrder; track v) {
            <div class="_bed-stage bed-available">
              <div class="bed-stage-icon">
                <img src="/assets/images/bedmanagement/{{v.value}}">
              </div>
              <div class="bed-stage-label">
                <label class="text-capitalize">{{v.key}}</label>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="row filter-grid" [hidden]="!(resource && resource.filter && resource.filter.default_open)">
        <ng-container>
          <!-- *ngIf="resource.filter != undefined && resource.filter.default_open" -->
          <div class="col-12 pl-4 pr-4">
            <div class="grid_filter">
              <div class="filter-body">
                <span class="close-filter-btn" (click)="displayFilter()">
                  <i class="fa fa-times-circle" aria-hidden="true"></i></span>
                  <div class="filter-form" [hidden]="!resource.filter">
                    <kx-filter #kxFilter [config]="filterConfig" [persistValue]="config" [fields]="resource.filter" (getFilter)="doSearch($event)" (getData)="getDataFn($event)"
                      (resetFilter)=resetFilter($event)>
                    </kx-filter>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    }
    <!--Bed Mgmt. Card-->
    @for (f of final_data; track f) {
      <div class="_card _bed-management-wrapper col-12 col-sm-12 col-md-6 col-lg-4 float-left"
        >
        <div class="_bed-management-content" [ngStyle]="{'background':(f.background|ColortoHex)}">
          <div class="_card-top-section">
            <div class="_card-label">
              {{f.ward_name}}
            </div>
            <div class="_card-count">
              {{f.total_count}}
            </div>
          </div>
          <div class="_card-middle-section">
            @for (p of f.ward_status; track p) {
              <div class="_card-content">
                <div class="_card-bed-count">
                  {{p.status_value}}
                </div>
                <div class="_card-icon">
                  <img src="/assets/images/bedmanagement/{{p.image}}">
                </div>
              </div>
            }
          </div>
          <div class="_card-bottom-section">
            <div class="_card-bottom-top">
              <div class="_card-occupancy">
                Occupancy
              </div>
              <div class="_card-occupancy-percentage">
                {{f.occupancy}}%
              </div>
            </div>
            <div class="progress" style="height:2px">
              <div class="progress-bar _progress-bg" role="progressbar" [ngStyle]="getWidth(f.occupancy)"
              aria-valuenow="{{f.occupancy}}" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
        </div>
      </div>
    }

  </div>